import React, { useEffect, useState } from "react";
import Layout from "../../../components/Layouts/Layouts/Layout";
import DashboardHeader from "../../../components/basic/DashboardHeader";
import MasterNavigationBar from "../../../components/Layouts/Layouts/MasterServicesLayout";
import { Button, Table, Modal, Form, Row, Col } from "react-bootstrap";
import { getURLbyEndPointV2 } from "../../../store/api";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FaCopy } from "react-icons/fa";

const CloudMeetings = () => {
  const [meetingData, setMeetingData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  // Base URL for user link
  const userBaseUrl = "https://e-platform.aecci.org.in";

  const [formData, setFormData] = useState({
    meetingTitle: "",
    userName: "",
    email: "",
    meetingDate: "",
    meetingTime: "",
  });

  const navigate = useNavigate();

  const fetchMeetings = async () => {
    try {
      const url = getURLbyEndPointV2("getAllCloudMeetings");
      const response = await axios.get(url);
      if (response.data.status) {
        setMeetingData(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching meetings:", error);
    }
  };

  useEffect(() => {
    fetchMeetings();
  }, []);

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleCreateMeeting = async () => {
    try {
      setLoading(true);
      const url = getURLbyEndPointV2("createCloudMeeting");
      const response = await axios.post(url, formData);

      if (response.data.status) {
        alert("Meeting Created Successfully!");
        setShowModal(false);
        setFormData({
          meetingTitle: "",
          userName: "",
          email: "",
          meetingDate: "",
          meetingTime: "",
        });
        fetchMeetings();
      } else {
        alert("Failed to create meeting.");
      }
    } catch (error) {
      console.error("Error creating meeting:", error);
      alert("Error creating meeting.");
    } finally {
      setLoading(false);
    }
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    alert("Copied to clipboard!");
  };

  const handleSyncRecording = async (meetingRoomId) => {
    try {
      const url = getURLbyEndPointV2("queryStatus");
      const response = await axios.post(url, { meetingRoomId });
      if (response.data.status) {
        alert("Recording data synced!");
        fetchMeetings(); // Refresh the list
      } else {
        alert(response.data.message || "Sync failed");
      }
    } catch (error) {
      console.error("Sync error:", error);
      alert("Failed to sync recording status.");
    }
  };

  const filteredData = meetingData.filter(
    (item) =>
      item.meetingTitle.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.userName.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  return (
    <Layout>
      <MasterNavigationBar>
        <div className="d-flex flex-column px-3">
          <DashboardHeader heading="CLOUD MEETINGS" backUrl="/master-events" />
          <hr />

          <div className="d-flex justify-content-between align-items-center mb-3">
            <Form.Control
              type="text"
              placeholder="Search by title or participate name..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{ maxWidth: "300px" }}
            />
            <Button onClick={() => setShowModal(true)}>Create Meeting</Button>
          </div>

          <Table responsive striped bordered hover>
            <thead>
              <tr className="text-center">
                <th>Sr No.</th>
                <th>Meeting Title</th>
                <th>Participate Name</th>
                <th>Date</th>
                <th>Time</th>
                <th>Meeting Link (Master)</th>
                <th>Meeting Link (User)</th>
                <th>View Recording</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.length > 0 ? (
                filteredData.map((item, index) => {
                  const masterLink = `/meeting-room/${item.meetingRoomId}`;
                  const userLink = `${userBaseUrl}/meeting-room/${item.meetingRoomId}`;

                  return (
                    <tr key={item._id} className="text-center">
                      <td>{index + 1}</td>
                      <td>{item.meetingTitle}</td>
                      <td>{item.userName}</td>
                      <td>{new Date(item.meetingDate).toLocaleDateString()}</td>
                      <td>{item.meetingTime}</td>
                      <td>
                        <a
                          href={masterLink}
                          target="_blank"
                          rel="noreferrer"
                          className="btn btn-sm btn-primary"
                        >
                          Join as Admin
                        </a>
                      </td>
                      <td>
                        <div className="d-flex justify-content-center align-items-center gap-2">
                          <Button
                            variant="outline-secondary"
                            size="sm"
                            onClick={() => copyToClipboard(userLink)}
                            title="Copy User Link"
                          >
                            <FaCopy />
                          </Button>
                        </div>
                      </td>
                      <td>
                        {item.recordingFileUrl ? (
                          <a
                            href={item.recordingFileUrl}
                            target="_blank"
                            rel="noreferrer"
                            className="btn btn-sm btn-info text-white"
                          >
                            View
                          </a>
                        ) : item.recordingTaskId ? (
                          <Button
                            variant="warning"
                            size="sm"
                            onClick={() =>
                              handleSyncRecording(item.meetingRoomId)
                            }
                            title="Click to sync if recording is stopped but not visible"
                          >
                            Sync Status
                          </Button>
                        ) : (
                          "N/A"
                        )}
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="8" className="text-center">
                    No Meetings Found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>

          {/* Create Meeting Modal */}
          <Modal show={showModal} onHide={() => setShowModal(false)} centered>
            <Modal.Header closeButton>
              <Modal.Title>Create Cloud Meeting</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
                <Form.Group className="mb-3">
                  <Form.Label>Meeting Title</Form.Label>
                  <Form.Control
                    type="text"
                    name="meetingTitle"
                    value={formData.meetingTitle}
                    onChange={handleInputChange}
                    placeholder="Enter Meeting Title"
                  />
                </Form.Group>
                <Row className="mb-3">
                  <Col>
                    <Form.Label>Participate Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="userName"
                      value={formData.userName}
                      onChange={handleInputChange}
                      placeholder="Participate Name"
                    />
                  </Col>
                  <Col>
                    <Form.Label>Email ID</Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      placeholder="Email ID"
                    />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col>
                    <Form.Label>Date</Form.Label>
                    <Form.Control
                      type="date"
                      name="meetingDate"
                      value={formData.meetingDate}
                      onChange={handleInputChange}
                    />
                  </Col>
                  <Col>
                    <Form.Label>Time</Form.Label>
                    <Form.Control
                      type="time"
                      name="meetingTime"
                      value={formData.meetingTime}
                      onChange={handleInputChange}
                    />
                  </Col>
                </Row>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowModal(false)}>
                Close
              </Button>
              <Button
                variant="primary"
                onClick={handleCreateMeeting}
                disabled={loading}
              >
                {loading ? "Saving..." : "Save Meeting"}
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </MasterNavigationBar>
    </Layout>
  );
};

export default CloudMeetings;
